module.exports = __webpack_public_path__ + "static/media/apple-macbook-gold-front.7d6e351f.png";